import React from "react"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    DialogActions,
    Button,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import _ from "lodash"

export default function ImportResultDialog({
    open,
    onClose,
    data = [],
    onSubmit,
    selectedClass,
    selectedRow,
    classExamList,
    isSubjectWiseTemplate,
    isMinorSubjectTemplate
}) {
    const columns = React.useMemo(() => {
        const colData = _.get(data, "data", [])
        if (!Array.isArray(colData) || colData.length === 0) return []
        return Object.keys(colData[0])
    }, [data])

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
        >
            {/* Header */}
            <DialogTitle sx={{ pr: 6 }}>
                Imported Excel Data Preview
                <IconButton
                    onClick={onClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            {/* Content */}
            <DialogContent dividers>
                <Box sx={{ maxHeight: "65vh", overflow: "auto" }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                {columns.map((col) => (
                                    <TableCell key={col} sx={{ fontWeight: 600 }}>
                                        {col.replaceAll("_", " ").toUpperCase()}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {Array.isArray(_.get(data, "data", null))  && _.get(data, "data", []).map((row, idx) => {
                                return (
                                    <TableRow key={idx}>
                                        {columns.map((col) => {
                                            let dataInfo = null
                                            let subjectList = null
                                            if(typeof(_.get(row,`${col}`,null)) === "string" || typeof(_.get(row,`${col}`,null)) === "number"){
                                                dataInfo = _.get(row,`${col}`,"")
                                            }
                                            if(_.get(row,`${col}`,null) && Array.isArray(_.get(row,`${col}`,null))){
                                                subjectList = _.get(row,`${col}`,[])
                                            }
                                            let subjects = []
                                            if(isMinorSubjectTemplate && _.get(row,'subjects',null)){
                                                subjects = _.get(row,"subjects",[])
                                            }


                                            if(isMinorSubjectTemplate && Array.isArray(subjectList) && subjectList.length > 0){
                                                return (
                                                    <TableCell key={col}>
                                                        {
                                                            dataInfo
                                                        }
                                                        <Table
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: 'transparent',
                                                                border: '1px solid rgba(0,0,0,0.08)',
                                                                borderRadius: 1,
                                                                maxWidth: 360,
                                                                overflowX: 'auto'
                                                            }}
                                                        >
                                                            <TableHead sx={{ backgroundColor: '#fff' }}>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: 700, borderRight: '1px solid rgba(0,0,0,0.08)' }}>Minor Subject Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: 700, borderRight: '1px solid rgba(0,0,0,0.08)' }}>Grade</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {
                                                                    subjectList.map((rowData,index)=> {
                                                                        return (
                                                                            <TableRow key={rowData.subject_name + index}>
                                                                                <TableCell sx={{ borderRight: '1px solid rgba(0,0,0,0.04)' }}>{rowData?.subject_name}</TableCell>
                                                                                <TableCell sx={{ borderRight: '1px solid rgba(0,0,0,0.04)' }}>{rowData?.grade}</TableCell>
                                                                            </TableRow>
                                                                        )
                                                                    })
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableCell>
                                                )
                                            }

                                            return (
                                                <TableCell key={col}>
                                                    {
                                                        dataInfo
                                                    }
                                                    {
                                                        Array.isArray(subjectList) &&
                                                        subjectList.length > 0 &&
                                                        (
                                                            (() => {
                                                                // convert to entries to align keys and values
                                                                const entries = Object.entries(row[col] || {})
                                                                return (
                                                                    <Table size="small" sx={{
                                                                        backgroundColor: 'transparent',
                                                                        border: '1px solid rgba(0,0,0,0.08)',
                                                                        borderRadius: 1,
                                                                        maxWidth: 360,
                                                                        overflowX: 'auto'
                                                                    }}>
                                                                        <TableHead sx={{ backgroundColor: '#fff' }}>
                                                                            <TableRow>
                                                                                <TableCell sx={{ fontWeight: 700, borderRight: '1px solid rgba(0,0,0,0.08)' }}>Name</TableCell>
                                                                                <TableCell sx={{ fontWeight: 700, borderRight: '1px solid rgba(0,0,0,0.08)' }}>Total</TableCell>
                                                                                <TableCell sx={{ fontWeight: 700, borderRight: '1px solid rgba(0,0,0,0.08)' }}>Theory</TableCell>
                                                                                <TableCell sx={{ fontWeight: 700, borderRight: '1px solid rgba(0,0,0,0.08)' }}>Practical</TableCell>
                                                                                <TableCell sx={{ fontWeight: 700 }}>Total Obtained</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {
                                                                                subjectList.map((sub, key) => {
                                                                                    return (
                                                                                        <TableRow key={sub.subject + key}>
                                                                                            <TableCell sx={{ borderRight: '1px solid rgba(0,0,0,0.04)' }}>{sub?.subject}</TableCell>
                                                                                            <TableCell sx={{ borderRight: '1px solid rgba(0,0,0,0.04)' }}>{sub?.total_mark}</TableCell>
                                                                                            <TableCell sx={{ borderRight: '1px solid rgba(0,0,0,0.04)' }}>{sub?.theory}</TableCell>
                                                                                            <TableCell sx={{ borderRight: '1px solid rgba(0,0,0,0.04)' }}>{sub?.practical}</TableCell>
                                                                                            <TableCell>{sub?.obtain_mark}</TableCell>
                                                                                        </TableRow>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </TableBody>
                                                                    </Table>
                                                                )
                                                            })()
                                                        )
                                                    }
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>

                    {!columns.length && (
                        <Typography align="center" sx={{ py: 4 }}>
                            No data found
                        </Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => {
                        if (!selectedClass || !selectedRow || !classExamList || !data) return
                        const findExam = classExamList.find(exam => exam.exam_name === selectedRow.Examination_Name)
                        let rawData = _.get(data, "data", [])
                        if (!Array.isArray(rawData) || rawData.length === 0) return

                        rawData = rawData.map((row)=> {
                            return {
                                ...row,
                                "status":row?.status ? row.status : "Yes"
                            }
                        })

                        if (!findExam) return
                        const dataInfo = {
                            school_id: selectedClass.institution_ref,
                            class_ref: selectedClass.id,
                            exam_ref: findExam.id,
                            results: [...rawData]
                        }
                        onSubmit(dataInfo)
                    }}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    )
}
